import { getColors } from "services/colors";

import "./styles.css";

const ColorPicker = ({
	selectedColor,
    onColorChange
}) => {
	const colors = getColors();
	
	return (
		<div className="d-flex gap-2">
			{colors.map((item, index) => (
				<div
					key={index}
					className={`color-circle ${selectedColor === item.value ? "selected" : ""
						} ${item.type === "empty" ? "empty" : ""}`}
					style={
						item.value
							? { backgroundColor: item.value }
							: {}
					}
					onClick={() => onColorChange(item.value)}
				>
					{selectedColor === item.value && (
						<span className="checkmark">✓</span>
					)}
				</div>
			))}
		</div>
	);
};

export default ColorPicker;